export enum BetslipState {
    // ADDING/REMOVING picks
    Edit = 'Edit',
    // After place bet button, waiting for result from server
    Placing = 'Placing',
    // Place bet result display state
    Result = 'Result',
}
